export default __webpack_public_path__ + "static/media/bigshotsCoin.1b9b9c7b.svg";